import { Chapter, FadeUp } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

const CLIENTS = [
  { name: "TNI AD", featured: true },
  { name: "Evonik", featured: true },
  { name: "iLink", featured: true },
  { name: "Kapal Api", featured: false },
  { name: "Good Day", featured: false },
  { name: "Gudang Garam", featured: false },
];

export default function Clients() {
  const { t } = useLanguage();

  return (
    <section className="py-28 md:py-40" data-testid="clients-section">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <Chapter number="08" title={t("chapters.clients")} />
        <FadeUp>
          <h2 className="mb-14 max-w-3xl text-balance font-syne text-3xl font-bold leading-[1.12] tracking-tight sm:text-4xl lg:text-[3.4rem] md:mb-20" data-testid="clients-heading">
            {t("clients.headingA")} <span className="text-[#F97316]">{t("clients.headingB")}</span>
          </h2>
        </FadeUp>
      </div>
      <FadeUp>
        <div className="marquee-pause overflow-hidden border-y border-white/10 py-10 md:py-14" data-testid="clients-marquee">
          <div className="animate-marquee flex w-max items-center gap-20 pr-20 md:gap-28 md:pr-28">
            {[...CLIENTS, ...CLIENTS].map((c, i) => (
              <span
                key={i}
                className={`flex items-center gap-20 font-syne text-2xl font-bold uppercase tracking-tight transition-colors duration-500 hover:text-white md:gap-28 md:text-4xl ${
                  c.featured ? "text-white/70" : "text-white/25"
                }`}
              >
                {c.name}
                <span className="h-2 w-2 bg-[#F97316]/60" aria-hidden="true" />
              </span>
            ))}
          </div>
        </div>
      </FadeUp>
      <div className="mx-auto mt-6 max-w-[1440px] px-6 md:px-12">
        <p className="font-spacemono text-[10px] uppercase tracking-[0.3em] text-white/30">{t("clients.caption")}</p>
      </div>
    </section>
  );
}
